import growhub from './GrowHub.svg';
export default function Loading() {
  return (
    <div className='flex items-center justify-center h-screen'>
      <img src={growhub} alt='Loading' className='w-36' />
    </div>
  );
}
